window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header')
	const menuItems = document.querySelector('header .menu-items')
	const hamburger = document.querySelector('header .hamburger')
	let previousScrollTop = 0
	window.addEventListener('scroll', e => {
		let currentScrollTop = window.scrollY

		if (previousScrollTop - currentScrollTop < 0 && currentScrollTop > 150) {
			header.classList.add('scrolled-down')
			closeMenu()
		} else {
			header.classList.remove('scrolled-down')
		}
		previousScrollTop = currentScrollTop
	})

	hamburger.addEventListener('click', e => {
		hamburger.classList.contains('open') ? closeMenu() : openMenu()
	})
	hamburger.addEventListener('keydown', e => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault()
			hamburger.classList.contains('open') ? closeMenu() : openMenu()
		}
	})

	window.addEventListener('click', e => {
		if (e.target.tagName != 'A' && !e.target.closest('.hamburger')) {
			closeMenu()
		}
	})

	function closeMenu() {
		hamburger.classList.remove('open')
		menuItems.classList.remove('open')
		hamburger.setAttribute('aria-expanded', 'false')
		menuItems.querySelectorAll('li').forEach(item => item.setAttribute('tabIndex', '-1'))
	}

	function openMenu() {
		hamburger.classList.add('open')
		menuItems.classList.add('open')
		hamburger.setAttribute('aria-expanded', 'true')
		menuItems.querySelectorAll('li').forEach(item => item.setAttribute('tabIndex', '0'))
	}
})
